import { render, staticRenderFns } from "./createtestimonial.vue?vue&type=template&id=31137292&"
import script from "./createtestimonial.vue?vue&type=script&lang=js&"
export * from "./createtestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports